(function($) {
	"use strict";
	
	function init() {
		$('.admin-event-signup-transfer').on('change', updateSignups);
		$('.refund-all-check').on('change', toggleRefundType);
		$('.refund-item').change(toggleItemsToRefund);
		$('.submit-refund-btn').click(submitRefund);
		$('.cancel-participation-btn').click(cancelParticipation);
        
        $('#sendReminder').on('submit', sendReminder);
	}

	function updateSignups({currentTarget}) {
		let ctn = $(currentTarget).closest('form');
		let input = ctn.find('input[name="signups"]');
		let values = input.val() && input.val().length ? input.val().split(',') : [];
		if (currentTarget.checked) {
			values.push(currentTarget.value);
		} else if (!currentTarget.checked && values.indexOf(currentTarget.value) > -1){
			values.splice(values.indexOf(currentTarget.value), 1);
		}
		input.val(values.join());
	}

	function toggleRefundType() {
		var input = $(this);
		var form = input.closest('form');

		if (input.val() === 'true') {
			form.find('.refundable-items').slideUp(function() {
				$(this).find('input[type=checkbox]:checked').trigger('click');
				$('.refund-amount').val(input.attr('data-amount')).closest('.inputText').addClass('filled');
			});
		} else {
			$('.refund-amount').val('').closest('.inputText').removeClass('filled');
			form.find('.refundable-items').slideDown();
		}
	}

	function toggleItemsToRefund() {
		var input = $(this);
		var form = input.closest('form');
		var total = 0;

		form.find('.refundable-items input[type=checkbox]').each(function() {
			var t = $(this);
			if (t.prop('checked')) {
				total = total + parseFloat(t.data('amount'));
			}
		});

		$('.refund-amount').val(total).closest('.inputText').addClass('filled');
	}

	function submitRefund() {
		var btn = $(this);
		var form = btn.closest('form');
		var toRefundSignups = [];
		var toRefundProducts = [];
		var productQties = [];

		if ($('[name=refund-all]:checked', form).length > 0) {
			$('[name=signupIds]', form).remove();
			$('[name=myProductIds]', form).remove();
			$('[name=quantitys]', form).remove();
			form.addClass('has-processing_active');

			form.find('.refundable-items input[type=checkbox]').each(function() {
				var t = $(this);
//                 || $('[name=refund-all]:checked', form).val() == "true"
				if (t.prop('checked')) {
					if (t.attr('data-type') === 'signup') {
						toRefundSignups.push(t.val());
					} else {
						var qty = t.attr('data-quantity').length ? t.attr('data-quantity') : 1;
						toRefundProducts.push(t.val());
						productQties.push(qty);
					}
				}
			});
			if (toRefundSignups.length > 0) {
				form.append('<input type="hidden" name="signupIds" value="'+ toRefundSignups.join() +'"/>');
			}

			if (toRefundProducts.length > 0) {
				form.append('<input type="hidden" name="myProductIds" value="'+ toRefundProducts.join() +'"/>');
				form.append('<input type="hidden" name="quantitys" value="'+ productQties.join() +'"/>');
			}

			form.submit();
		}
	}

	function cancelParticipation() {
		var btn = $(this);
		var signupId = btn.attr("data-signup-id");

		$.ajax({
			url: '/action/pmiSignupAdmin',
			method: 'post',
			data: {
				"delete": true,
				signupId,
				"ajax": true
			},
			cache: false,
			complete: function(response) {
				var r = response.responseText;
				console.log(r);
				location.reload();
			}
		});
	}
    
    function sendReminder(e) {
        e.preventDefault();
        const $form = $(e.currentTarget);
        const elems = $form[0].elements;
        
        if ($form.find('.submitButton').prop('disabled')) {
            return false;
        }
        $form.find('.form-message').hide();
        $form.find('.submitButton').prop('disabled', true).addClass('grey').removeClass('blue');
        
		$.ajax({
			url: $form.attr('action'),
			method: 'post',
			data: {
                ajax: true,
                paymentId: elems.paymentId.value,
                eventId: elems.eventId.value,
                sendTo: elems.sendTo.value
            },
			cache: false,
			success: (response) => {
				$form.find('.form-message_success').show();
			},
            error: () => {
                $form.find('.form-message_server-error').show();
            },
            complete: () => {
                $form.find('.submitButton').prop('disabled', false).addClass('blue').removeClass('grey');
            }
		});
    }
	
	$(init);
	
})(jQuery);